export default __webpack_public_path__ + "static/media/delivery-cycle.ee13e2d4.svg";